var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import { Translate } from "../../../../I18N";
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline';











const MultiselectListGroup = ({
  children,
  isOpen,
  foldable,
  label,
  onClick,
  itemContainerClassName,
  itemClassName
}) => {
  if (foldable) {
    return (/*#__PURE__*/
      _jsx("li", { className: `${itemClassName !== null && itemClassName !== void 0 ? itemClassName : 'bg-gray-50 rounded-lg mb-4'}` }, void 0, /*#__PURE__*/
      _jsx("div", {
        className: `flex justify-between p-3 mb-4 rounded-lg ${isOpen ? 'bg-indigo-50' : 'bg-gray-50'}`,
        onClick: onClick }, void 0, /*#__PURE__*/

      _jsx("span", { className: "block text-sm font-bold text-gray-900" }, void 0, label), /*#__PURE__*/
      _jsx("button", {
        className: "text-indigo-800 bg-indigo-200 rounded-[6px] text-xs font-medium px-1.5 py-0.5 flex flex-row items-center justify-center gap-1",
        type: "button" }, void 0, /*#__PURE__*/

      _jsx("div", { className: "w-3 h-3 text-sm" }, void 0,
      isOpen ? /*#__PURE__*/_jsx(ChevronUpIcon, {}) : /*#__PURE__*/_jsx(ChevronDownIcon, {})
      ), /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Group")
      )
      ),
      isOpen && /*#__PURE__*/_jsx("ul", { className: `${itemContainerClassName !== null && itemContainerClassName !== void 0 ? itemContainerClassName : 'pl-4 '}` }, void 0, children)
      ));

  }

  return (/*#__PURE__*/
    _jsx("li", { className: `${itemClassName !== null && itemClassName !== void 0 ? itemClassName : 'bg-gray-50 rounded-lg mb-4'}` }, void 0, /*#__PURE__*/
    _jsx("span", { className: "block mb-4 text-sm font-bold text-gray-900" }, void 0, label), /*#__PURE__*/
    _jsx("ul", { className: `${itemContainerClassName !== null && itemContainerClassName !== void 0 ? itemContainerClassName : ''}` }, void 0, children)
    ));

};

export { MultiselectListGroup };